<template>
	<div class="item-title">
		
		<template v-for="(item,index) in headers" >
			<label style="color:#9e9e9e;" :key="item.index" v-if="index != 0">>></label>
			<label :key="item.label" :class="item.path ? 'isable' : ''" @click="change(item.path)">
				{{ item.label }}
			</label>

		</template>
	</div>
</template>

<script>
export default {
    props:{
        headers:{
            default () { return []; }
        }
    },
    methods:{
        change (path) {
            if(path)
                this.$router.push(path);
        }
    }
};
</script>

<style lang="less" scoped>
	.item-title{
		height:18px;
		line-height: 18px;
		font-weight: bold;
		font-size: 16px;
		border-left: 3px solid rgb(253,107,107);
		margin:20px 0 15px 0;
		padding-left: 5px;
		label.isable:hover{
			cursor: pointer;
			color: #18a1fd;
		}
	}
</style>